import Header from "./component/Header";
import { Element } from "react-scroll";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Work from "./pages/Work";
import CursorPointer from "./component/CursorPointer";
import About from "./pages/About";
import Footer from "./pages/Footer";
import { Route, Routes } from "react-router-dom";
import Contact from "./component/Contact";
import { Toaster } from "react-hot-toast";
import WorkDetail from "./component/WorkDetail";
import EnquiryPopup from "./component/EnquiryPopup";

function App() {
  return (
    <div className=" relative overflow-hidden">
      <CursorPointer trailDelay={0.08} />
      <Header />

      <Element name="/" className="">
        <Home />
      </Element>
      <Element name="about">
        <About />
      </Element>

      <Element name="work">
        <Work />
      </Element>

      <Element>
        <WorkDetail name="workDetail" />
      </Element>

      <Element name="service">
        <Services />
      </Element>
      <Element name="contact">
        <Contact />
      </Element>

      <Element name="footer">
        <Footer />
      </Element>

      <Toaster position="top-right" reverseOrder={false} />
    </div>
  );
}

export default App;
